module.exports = __webpack_public_path__ + "img/sprinkle-17.7da5a359.jpg";